module.exports = __webpack_public_path__ + "_/src/containers/status_embed/position_preview_status_embed-796f952f30088cf8bcbabb7e9cc73222.svg";